// extracted by mini-css-extract-plugin
export default {"key":"tag-selector_key__7uOWa"};